import { useEffect } from "react";

export const SITE_URL = "https://www.ananshawelfaresociety.in";
export const SITE_NAME = "अंशा वेलफेयर सोसाइटी | Anansha Welfare Society";

function setMeta(selector, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const m = selector.match(/\[(name|property)="(.+?)"\]/);
    if (m) el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "/", image, type = "website", breadcrumb, jsonLd }) {
  const fullTitle = path === "/" ? title : `${title} | Anansha Welfare Society`;
  const url = `${SITE_URL}${path}`;
  const img = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : `${SITE_URL}/assets/banner.jpg`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', fullTitle);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[property="og:type"]', type);
    setMeta('meta[property="og:image"]', img);
    setMeta('meta[name="twitter:card"]', "summary_large_image");
    setMeta('meta[name="twitter:title"]', fullTitle);
    setMeta('meta[name="twitter:description"]', description);
    setMeta('meta[name="twitter:image"]', img);
    setCanonical(url);

    const schemas = [];
    if (breadcrumb && breadcrumb.length) {
      schemas.push({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "होम", item: SITE_URL },
          ...breadcrumb.map((b, i) => ({ "@type": "ListItem", position: i + 2, name: b, item: url })),
        ],
      });
    }
    if (jsonLd) schemas.push(...(Array.isArray(jsonLd) ? jsonLd : [jsonLd]));

    const added = [];
    document.head.querySelectorAll('script[data-seo-dynamic]').forEach((s) => s.remove());
    schemas.forEach((schema) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-dynamic", "1");
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
      added.push(s);
    });
    return () => added.forEach((s) => s.remove());
  }, [fullTitle, description, url, img, type]);

  return null;
}
